module.exports = __webpack_public_path__ + "static/Sonyax45-d81201fb438895707b7a0b5c8a19ee8c.png";